module Hereabout.UI.Components.GPSFeedComponent where

import Prelude

import Data.Array as A
import Data.Either (Either(..))
import Data.Maybe (Maybe(..))
import Effect.Aff (Milliseconds(..))
import Effect.Aff as Aff
import Effect.Aff.Class (class MonadAff)
import Effect.Class (class MonadEffect, liftEffect)
import Effect.Class.Console (log)
import Halogen as H
import Halogen.HTML as HH
import Halogen.HTML.Events as HE
import Halogen.HTML.Properties as HP
import Halogen.Subscription as HS
import Hereabout.Data.Route (CommunityFeedTab(..), HereaboutPage(..), Route(..))
import Hereabout.Effects (class LocationFeed, class Navigate, class ShareURL, getFeed, navigate)
import Hereabout.Navigator.Geolocation (GeolocationError(..), Position(..), PositionMissing(..), accuracy, watchCurrentPosition)
import Hereabout.Types (CommunityFeed(..), Event(..), Venue(..))
import Hereabout.UI.Bulma.Classes as Bulma
import Hereabout.UI.Components.CommunityFeedComponent as ComFeedComp
import Hereabout.UI.Components.CommunityListComponent as ComListComp
import Hereabout.UI.SemanticUI.Classes as SemUI
import Type.Proxy (Proxy(..))

data Action
  = InitialiseApp
  | ReceivePosition Position
  | ReceivedGeolocationError GeolocationError
  | PositionTimedOut

type Slot id = forall q. H.Slot q Void id


type State =
  { position :: Either PositionMissing Position
  , feed :: Maybe CommunityFeed
  }

type ChildSlots =
  ( comFeed :: ComFeedComp.Slot String
  , comList :: ComListComp.Slot Unit
  )

component :: forall q o m. MonadAff m => MonadEffect m => Navigate m => LocationFeed m => ShareURL m => H.Component q Unit o m
component =
  H.mkComponent
    { initialState: \unit -> { position : Left AwaitingPosition, feed : Nothing }
    , render
    , eval: H.mkEval H.defaultEval { handleAction = handleAction, initialize = Just InitialiseApp }
    }

render :: forall m. MonadAff m => MonadEffect m => Navigate m => LocationFeed m => ShareURL m => State -> H.ComponentHTML Action ChildSlots m
render state = 
  case {one : state.feed, two : state.position} of
    { one : Just (CommunityFeed feed), two : Right pos } -> HH.slot_ (Proxy :: _ "comFeed") feed.id ComFeedComp.component { communityFeed : CommunityFeed feed, cfTab : CommunityFeedEventTab }
    _ -> 
      HH.section [ HP.classes [ Bulma.hero, Bulma.isFullHeight ] ]
        [ HH.div [ HP.classes [ Bulma.heroBody ] ]
          [ HH.progress [ HP.classes [ Bulma.progress, Bulma.isLarge, Bulma.isDanger ] ] []
          ]
        ]
      

handleAction :: forall cs o m. MonadAff m => MonadEffect m => LocationFeed m => Navigate m => Action -> H.HalogenM State Action cs o m Unit
handleAction InitialiseApp = do
  _ <- H.subscribe =<< gpsEmitter
  pure unit
handleAction (ReceivePosition (Position pos)) = do
  _ <- H.liftEffect $ log $ show pos
  if accuracy (Position pos) <= 50000.0 then  do -- accept positions with 5km accuracy or better
    feed <- H.lift $ getFeed pos.coords
    H.modify_ _ { position = Right (Position pos), feed = Just feed}
  else
    pure unit
handleAction PositionTimedOut = do
  state <- H.get
  case state.position of
    Left AwaitingPosition -> do
      H.liftEffect $ log $ "Position timed out"
      handleAction $ ReceivedGeolocationError GeolocationTimeout
    _ ->
      pure unit
handleAction (ReceivedGeolocationError err) = do
  state <- H.get
  case state.position of
    Right pos -> pure unit
    Left _ -> do
      H.liftEffect $ log $ "Error acquiring  GPS position" <> show err
      H.lift $ navigate $ CommunityListRoute

gpsEmitter ∷ forall m. Bind m ⇒ MonadEffect m ⇒ MonadAff m ⇒ m (HS.Emitter Action)
gpsEmitter = do
  { emitter, listener } <- H.liftEffect HS.create
  _ <- H.liftAff $ Aff.forkAff do
    liftEffect $ watchCurrentPosition (\pos -> HS.notify listener $ ReceivePosition pos) (\err -> HS.notify listener $ ReceivedGeolocationError err)
    Aff.delay $ Milliseconds 5000.0
    liftEffect $ HS.notify listener $ PositionTimedOut
    --liftEffect $ HS.notify listener $ ReceivePosition $ Position { coords : { latitude : 51.369, longitude: -0.3636, accuracy :10.0 }, timestamp: 1 }
  pure emitter


